export default {
  title: 'Bank Details',
  buttons: {
    save: 'Save',
  },
  toasts: {
    success: 'Successfully saved your information.',
  },
};
